import * as React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import LangHeading from "../LangHeading";
import type { IPageParams } from "../Main";
import ModuleSelector from "../ModuleSelector";
import PageNav from "../PageNav";
import { useTranslations } from "../queries/useTranslations";
import { type IState, defaultContentPageSelector } from "../state";
import { getInt } from "../utils";
import Counts from "./Counts";
import DefaultContentFormatting from "./DefaultContentFormatting";
import DefaultContentRow from "./DefaultContentRow";

function DefaultContent() {
    const { version, page } = useParams<IPageParams>();
    if (!version) {
        throw new Error("Version is undefined");
    }
    const { data: translations } = useTranslations(version);
    const pageNr = getInt(page) ?? 1;
    const { ids, pageCount } = useSelector((state: IState) =>
        defaultContentPageSelector(state, version, translations!, pageNr),
    );

    return (
        <>
            <ModuleSelector content={"defaultContent"} version={version} />
            <DefaultContentFormatting />
            <Counts version={version} content="defaultContent" />
            <PageNav page={pageNr} maxPage={pageCount} version={version} content="default-content" />
            <LangHeading />
            <div>
                {ids.map((id) => (
                    <DefaultContentRow key={id} id={id} version={version} />
                ))}
            </div>
            <PageNav page={pageNr} maxPage={pageCount} version={version} content="default-content" />
        </>
    );
}

export default React.memo(DefaultContent);
